import type { z } from 'zod';

export const ErrorMessage = {
  ean18: 'zod.errors.invalid_ean18',
  either: 'zod.errors.either',
  elecEan18Incorrect: 'zod.errors.ean18_incorrect_electricity',
  gasEan18Incorrect: 'zod.errors.ean18_incorrect_gas',
  required: 'zod.errors.required',
} as const;

/**
 * Translated 'required' error when string should be larger than 1 instead of the default error
 * TODO: transform "" into undefined with React Hook Form, then we don't need this anymore
 */
export const requiredError: z.core.$ZodErrorMap = (issue) => {
  if (
    issue.code === 'too_small' &&
    issue.minimum === 1 &&
    issue.origin === 'string'
  ) {
    return { message: ErrorMessage.required };
  }
};

export function buildErrorMap({
  errors,
  fallbackErrorMap,
}: {
  errors: z.core.$ZodErrorMap[];
  fallbackErrorMap: z.core.$ZodErrorMap;
}): z.core.$ZodErrorMap {
  return (issue) => {
    // Find the last error that matches the issue
    const matchingError = errors.findLast((error) => error(issue));

    // If a matching error is found, call it with the issue
    if (matchingError) return matchingError(issue)!;

    // If no matching error is found, use the fallback error map
    return fallbackErrorMap(issue);
  };
}
